// extracted by mini-css-extract-plugin
export default {"main":"CardTextInput_main__3l9ta"};